module.exports = __webpack_public_path__ + "static/media/chat.1881aa82.svg";